module.exports = {
  PARCEL_SUNDAY: "1^01",
  SWAPIT_SUNDAY: "1^03",
  SWAPIT_SUNDAY_12_00: "1^04",
  SWAPIT_SUNDAY_10_30: "1^05",
  FREIGHT_PARCEL_SUNDAY: "1^06",
  PARCEL_SUNDAY_10_30: "1^07",
  PALLET_SUNDAY: "1^08",
  EXPRESSPAK_SUNDAY: "1^09",
  PARCEL_DPD_TWO_DAY: "1^11",
  PARCEL_DPD_NEXT_DAY: "1^12",
  PARCEL_DPD_12_00: "1^13",
  PARCEL_DPD_10_30: "1^14",
  PARCEL_SATURDAY: "1^16",
  PARCEL_SATURDAY_12_00: "1^17",
  PARCEL_SATURDAY_10_30: "1^18",
  PARCEL_DPD_CLASSIC: "1^19",
  HOME_DELIVERY_EVENING: "1^21",
  EXPRESSPAK_SUNDAY_10_30: "1^23",
  FREIGHT_PARCEL_SUNDAY_10_30: "1^24",
  HOME_DELIVERY_AFTERNOON: "1^25",
  PALLET_SUNDAY_10_30: "1^28",
  PARCEL_SUNDAY_12_00: "1^29",
  FREIGHT_PARCEL_SUNDAY_12_00: "1^31",
  EXPRESSPAK_DPD_NEXT_DAY: "1^32",
  EXPRESSPAK_DPD_12_00: "1^33",
  EXPRESSPAK_DPD_10_30: "1^34",
  EXPRESSPAK_SATURDAY: "1^36",
  EXPRESSPAK_SATURDAY_12_00: "1^37",
  EXPRESSPAK_SATURDAY_10_30: "1^38",
  EXPRESSPAK_DPD_CLASSIC: "1^39",
  SWAPIT_DPD_TWO_DAY: "1^41",
  SWAPIT_DPD_NEXT_DAY: "1^42",
  SWAPIT_IT_DPD_12_00: "1^43",
  SWAPIT_DPD_10_30: "1^44",
  SWAPIT_SATURDAY: "1^46",
  SWAPIT_SATURDAY_12_00: "1^47",
  SWAPIT_SATURDAY_10_30: "1^48",
  SWAPIT_AFTERNOON: "1^49",
  AIR_EXPRESS: "1^50",
  EXPRESSPAK_SUNDAY_12_00: "1^51",
  SWAPIT_EVENING: "1^53",
  DPD_DIRECT_IE: "1^58",
  PARCEL_HOMECALL: "1^59",
  AIR_CLASSIC: "1^60",
  PALLET_SUNDAY_12_00: "1^69",
  PALLET_DPD_TWO_DAY: "1^71",
  PALLET_DPD_NEXT_DAY: "1^72",
  PALLET_DPD_10_30: "1^74",
  PALLET_SATURDAY: "1^76",
  PALLET_SATURDAY_12_00: "1^77",
};
